// extracted by mini-css-extract-plugin
module.exports = {"Container":"NewsPage_Container__KjKto","ShowMore":"NewsPage_ShowMore__3MRfG"};